import { useCallback } from 'react';

import { useDeleteConsumerFamily, useShowConsumerFamily } from '@givebacks/api/backer';
import { Button, Modal, Text, notifications } from 'ui';

import { getErrorMessage_v2 } from '../../../../../utils/errorMessage';
import {
  ModalTitleWithBackButton,
  useDirectorySettingsModalProvider,
} from '../DirectorySettingsModalProvider';

const DeleteFamilyModalFooter = ({ familyName }: { familyName: string }) => {
  const { openModalById, meta } = useDirectorySettingsModalProvider({});
  const { mutate: deleteConsumerFamily } = useDeleteConsumerFamily();

  const handleDelete = useCallback(() => {
    if (!meta.familyId) return;
    deleteConsumerFamily(
      { familyId: meta.familyId },
      {
        onSuccess: () => {
          notifications.show({
            message: `You've deleted ${familyName} family`,
            variant: 'success',
          });
          openModalById('families');
        },
        onError: (error) => {
          notifications.show({
            message: getErrorMessage_v2(error),
            variant: 'error',
          });
        },
      }
    );
  }, [deleteConsumerFamily, meta.familyId, openModalById, familyName]);
  return (
    <Modal.AffixedFooter>
      <Button color="cerise" fullWidth onClick={handleDelete}>
        Confirm Delete
      </Button>
    </Modal.AffixedFooter>
  );
};

const DeleteFamilyModalContent = () => {
  const { meta } = useDirectorySettingsModalProvider({
    id: 'delete',
  });
  const { data: family } = useShowConsumerFamily({
    familyId: meta.familyId,
  });
  const familyName = family?.name ?? 'this';

  if (!family) return null;
  return (
    <>
      <Text fw={600}>Are you sure you want to delete {familyName} family?</Text>
      <DeleteFamilyModalFooter familyName={familyName} />
    </>
  );
};

const DeleteFamilyModal = () => {
  const { opened, close } = useDirectorySettingsModalProvider({
    id: 'delete',
  });

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton>Delete Family</ModalTitleWithBackButton>}
    >
      <DeleteFamilyModalContent />
    </Modal>
  );
};

export { DeleteFamilyModal };
